import { Navigate, useParams } from '@exam-center/router';

export default function ExamCenterPage() {
  const { examCenterCode } = useParams('/:examCenterCode');

  return <Navigate to='/:examCenterCode/home' params={{ examCenterCode }} />;
}
